import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../../app/store";

export const enum PopupModalName {
    DELETE_BOT = "DELETE_BOT",
    DELETE_LOCATION = "DELETE_LOCATION",
    DELETE_FRANCHISE = "DELETE_FRANCHISE",
    VIEW_MORE = "VIEW_MORE",
    REIMPORT_VEHICLES = "REIMPORT_VEHICLES",
    UNSAVED_CHANGES = "UNSAVED_CHANGES",
    DELETE_INTEGRATION = "DELETE_INTEGRATION",
    CHANGE_OFFER_STATUS = "CHANGE_OFFER_STATUS",
    PREVIEW_OFFERS = "PREVIEW_OFFERS",
    CONFIGURATION_ISSUES = "CONFIGURATION_ISSUES",
    DELETE_KNOWLEDGE_RECORD = "DELETE_KNOWLEDGE_RECORD",
    DELETE_KNOWLEDGE_DEFINITION = "DELETE_KNOWLEDGE_DEFINITION",
    VIEW_ROUTING_DECISION = "VIEW_ROUTING_DECISION",
    IMPORT_ASSISTANT = "IMPORT_ASSISTANT",
    CLONE_ASSISTANT = "CLONE_ASSISTANT",
}


export interface ModalState {
    isPopupModalOpen: boolean
    isAnimationFinished: boolean
    openedPopupModal?: PopupModalName
    popupModalProps: Record<string, any>
}

const initialState: ModalState = {
    isPopupModalOpen: false,
    isAnimationFinished: true,
    popupModalProps: {}
};


export const popupModalSlice = createSlice({
    name: 'popupModal',
    initialState,
    reducers: {
        openPopupModal: (state, {payload}: PayloadAction<{
            name: PopupModalName,
            popupModalProps?: Record<string, any>
        }>) => {
            state.isPopupModalOpen = true
            state.isAnimationFinished = true
            state.openedPopupModal = payload.name
            if (payload.popupModalProps) {
                state.popupModalProps = payload.popupModalProps
            }
        },
        closePopupModal: (state) => {
            state.isPopupModalOpen = false
            state.isAnimationFinished = false
            state.popupModalProps = {}
        },
        endAnimation: (state) => {
            state.isAnimationFinished = true
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    openPopupModal,
    closePopupModal,
    endAnimation
} = popupModalSlice.actions;

export const popupModalPropsSelector = (state: RootState): any => state.popupModal.popupModalProps;
export const isPopupModalOpenSelector = (state: RootState): boolean => state.popupModal.isPopupModalOpen;
export const openedPopupModalSelector = (state: RootState): PopupModalName | undefined => state.popupModal.openedPopupModal;
export const isAnimationFinishedSelector = (state: RootState): boolean => state.popupModal.isAnimationFinished;
